import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { GetFinanceInfoForVendorPayload } from "../../payload/GetFinanceInfoForVendor/GetFinanceInfoForVendorPayload";

const getFinanceInfoForVendorFetch = (state: ClientsState, actions: PayloadAction<GetFinanceInfoForVendorPayload>) => {
    state.isLoading = true;
}

export default getFinanceInfoForVendorFetch;